import React from 'react'

export const NotFoundPage = () => {
  return <div className="not-found">Not Found</div>
}
